import { removeDupes } from '../utils/helpers';

const notifications = (state = {
    items: [],
    fetchInfo: {
        team: {},
        user: {}
    },
    shouldRefetch: false
}, action) => {
    if (action.error) {
        return state;
    }

    switch (action.type) {
        case 'TEAM_CHANGE':
        case 'RESET_STORE':
        case 'NOTIFICATIONS_RESET_REQUESTED':
            return {
                items: [],
                fetchInfo: {
                    team: {},
                    user: {}
                }
            };

        case 'MARK_ALL_FOR_REFETCH':
            return Object.assign({}, state, {
                shouldRefetch: true
            });

        case 'NOTIFICATIONS_FETCH_REQUESTED': {
            if (action.payload.triggeredBy) {
                return Object.assign({}, state, {
                    fetchInfo: {
                        ...state.fetchInfo,
                        user: {
                            ...state.fetchInfo.user,
                            [action.payload.triggeredBy]: {
                                loading: true
                            }
                        }
                    }
                });
            }

            return Object.assign({}, state, {
                fetchInfo: {
                    ...state.fetchInfo,
                    team: {
                        ...state.fetchInfo.team,
                        error: false,
                        loading: true
                    }
                }
            });
        }

        case 'NOTIFICATIONS_FETCH_FAILED': {
            if (action.payload.triggeredBy) {
                return Object.assign({}, state, {
                    fetchInfo: {
                        ...state.fetchInfo,
                        user: {
                            ...state.fetchInfo.user,
                            [action.payload.triggeredBy]: {
                                ...state.fetchInfo.user[action.payload.triggeredBy],
                                loading: false,
                                error: true
                            }
                        }
                    }
                });
            }

            return Object.assign({}, state, {
                fetchInfo: {
                    ...state.fetchInfo,
                    team: {
                        ...state.fetchInfo.team,
                        loading: false,
                        error: true
                    }
                }
            });
        }

        case 'NOTIFICATIONS_FETCH_SUCCEEDED': {
            if (action.payload.triggeredBy) {
                return Object.assign({}, state, {
                    items: removeDupes([
                        ...action.payload.notifications,
                        ...state.items
                    ]),
                    fetchInfo: {
                        ...state.fetchInfo,
                        user: {
                            ...state.fetchInfo.user,
                            [action.payload.triggeredBy]: {
                                ...state.fetchInfo.user[action.payload.triggeredBy],
                                loading: false,
                                fetched: true,
                                hasMore: action.payload.hasMore
                            }
                        }
                    }
                });
            }

            return Object.assign({}, state, {
                items: removeDupes([
                    ...action.payload.notifications,
                    ...state.items
                ]),
                fetchInfo: {
                    ...state.fetchInfo,
                    team: {
                        ...state.fetchInfo.team,
                        loading: false,
                        fetched: true,
                        hasMore: action.payload.hasMore,
                        readFetched: state.fetchInfo.team.readFetched || !action.payload.unreadOnly
                    }
                }
            });
        }

        case 'NOTIFICATION_ADD_SOCKET':
            return Object.assign({}, state, {
                items: removeDupes([action.payload.notification, ...state.items])
            });

        case 'NOTIFICATIONS_READ_REQUESTED':
        case 'NOTIFICATIONS_READ_SOCKET':
            return Object.assign({}, state, {
                items: [...state.items].map(notification => {
                    if (action.payload.notificationIds.includes(notification.id)) {
                        return Object.assign({}, notification, {
                            is_read: true
                        });
                    }

                    return notification;
                })
            });

        case 'NOTIFICATIONS_UNREAD_REQUESTED':
        case 'NOTIFICATIONS_UNREAD_SOCKET':
            return Object.assign({}, state, {
                items: [...state.items].map(notification => {
                    if (action.payload.notificationIds.includes(notification.id)) {
                        return Object.assign({}, notification, {
                            is_read: false
                        });
                    }

                    return notification;
                })
            });

        case 'NOTIFICATIONS_UPDATE_SOCKET':
            return Object.assign({}, state, {
                items: [...state.items].map(notification => {
                    if (action.payload.notification.id === notification.id) {
                        return Object.assign({}, notification, action.payload.notification);
                    }

                    return notification;
                })
            });

        case 'NOTIFICATION_READ_ALL_REQUESTED':
            return Object.assign({}, state, {
                items: [...state.items].map(notification => {
                    return Object.assign({}, notification, {
                        is_read: true
                    });
                })
            });

        case 'NOTIFICATIONS_REMOVE_REQUESTED':
        case 'NOTIFICATIONS_REMOVE_SOCKET':
            return Object.assign({}, state, {
                items: state.items.filter(notification => !action.payload.notificationIds.includes(notification.id))
            });

        default:
            return state;
    }
}

export default notifications;
